import React from 'react'
import {makeStyles, Typography} from '@material-ui/core';
import Dialog from 'components/Dialog';
import Tr from 'translations/Translations';
import GridBlock from 'components/GridBlock';
import Form from 'components/Form';
import useId from 'hooks/useId';
import {connect} from 'react-redux'
import DoubleButton from 'components/popup/components/DoubleButton';
import Select from 'components/Select';
import VS from 'constants/ValidationShema';
import BooleanItems from "constants/BooleanItems";
import SiwzService from "services/SiwzService";
import {SiwzSourceType} from "./constants/SiwzSourceType";
import PropTypes from "prop-types";

const useStyle = makeStyles(theme => ({
    text: {
        marginBottom: theme.spacing(2),
    },
    gridContainer: {
        marginBottom: theme.spacing(2)
    },
    fileName: {
        width: 300
    },
    select: {
        width: 200,
        marginLeft: theme.spacing(2)
    },
    parentSelect: {
        width: 200,
    }
}));

function SelectSiwzDocumentType(
    {
        items,
        onCancel,
        onSubmit,
        pickAutopublish,
        pickParent,
        formSubmit,
        types,
        siwzList
    }) {

    const classes = useStyle();

    const formId = useId();
    const selectId = 'item';
    const parentId = 'parent';
    const autopublishId = 'autopublish';

    const createSelectTab = () => {
        if (types === undefined) return '';
        return Object.keys(types).map(x => ({value: x, label: types[x]}));
    }

    const createParentSelectTab = () => {
        if (siwzList === undefined) return '';
        const tab = [];
        tab.push({
            label: Tr('new'),
            value: 0
        });
        siwzList.filter(x => x.source === SiwzSourceType.SIWZ).forEach((x) => {
            tab.push({
                label: x.name,
                value: x.identity
            })
        })

        return tab
    }

    const generateItems = (formikProps) => {
        if (items.length === 0) {
            return <Typography>{Tr("file_extension_error")}</Typography>
        }
        return items.map((item, i) => {
            return (
                <GridBlock key={i} justify="space-between" alignItems="center">
                    <Typography className={classes.fileName}> {item.name}</Typography>

                    {pickParent && <Select
                        id={parentId + i}
                        formikProps={formikProps}
                        items={createParentSelectTab()}
                        label={Tr('parent_document_select')}
                        className={classes.select}
                        onChange={(event) => {if(event.target.value !== 0) formikProps.setFieldValue(selectId + i, '') }}
                    />}

                    <Select
                        id={selectId + i}
                        formikProps={formikProps}
                        items={createSelectTab()}
                        label={Tr('document_type')}
                        className={classes.select}
                        disabled={formikProps.values[parentId + i] !== 0}
                    />

                    {pickAutopublish && <Select
                        id={autopublishId + i}
                        formikProps={formikProps}
                        items={BooleanItems}
                        label={Tr('auto_publish')}
                        className={classes.select}
                    />}

                </GridBlock>
            )
        })
    };

    const submitForm = () => {
        formSubmit[formId]()
    };

    const generateInitialValues = () => {
        let obj = {};
        for (let i = 0; i < items.length; i++) {
            obj[selectId + i] = "";
            obj[parentId + i] = 0;
            obj[autopublishId + i] = false;
        }
        return obj
    };

    const generateValidationSchema = () => {
        let obj = {};
        for (let i = 0; i < items.length; i++) {
            obj[selectId + i] = VS.stringMaxNoRq(2048)
                .when( parentId+i, (other, schema) => other === 0 ? VS.string() : schema)
        }

        return VS.object(obj)
    };

    const handleSubmit = (values) => onSubmit(values, items)

    if (items === undefined) return '';
    return (
        <Dialog
            open
            title={Tr('select_document_type')}
            titleCentered
            maxWidth={'xl'}
            fullWidth={false}
            paperClassName={classes.paperClassName}
        >
            <Form
                onSubmit={handleSubmit}
                id={formId}
                initialValues={generateInitialValues()}
                validationSchema={generateValidationSchema()}
            >
                {(formikProps) => (
                    <>
                        <GridBlock column className={classes.gridContainer}>
                            {generateItems(formikProps)}
                        </GridBlock>

                        <DoubleButton
                            justify='flex-end'
                            labelFirst={Tr('cancel')}
                            labelSecond={Tr('add')}
                            onClickFirst={onCancel}
                            onClickSecond={submitForm}
                        />
                    </>
                )}
            </Form>

        </Dialog>
    )
}

SelectSiwzDocumentType.propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string.isRequired
    })).isRequired,
    onCancel: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    pickAutopublish: PropTypes.bool.isRequired,
    pickParent: PropTypes.bool.isRequired,
};

export default connect((state) => ({
    formSubmit: state.form,
    types: state.resources[SiwzService.SIWZ_TYPE_LIST_RESOURCE_ID],
    siwzList: state.resources[SiwzService.SIWZ_LIST_RESOURCE_ID],
}), {})(SelectSiwzDocumentType);